<div [style]="style" [classList]="styleClass ? styleClass : 'h-full'">
    <div class="avatar" [class.avatar--empty]="currentValue === null">
        @if (currentValue !== null) {
            <img [src]="currentValue" alt="FICSIT" />
        } @else {
            <span class="avatar__placeholder">{{ placeholder ?? '?' }}</span>
        }
    </div>
    @if (!disabled) {
        <p-button
            class="ml-2"
            severity="secondary"
            [label]="label"
            [icon]="icon"
            (onClick)="handleFileRequest($event)" />
    }
    <input
        #fileInput
        hidden
        type="file"
        [attr.id]="inputId ?? null"
        [disabled]="disabled"
        [accept]="accept"
        [multiple]="false"
        (change)="handleFileUpload($event)" />
    @if (currentValue !== null && !disabled) {
        <p-button
            class="ml-2"
            icon="ms ms-close"
            severity="secondary"
            [text]="true"
            [rounded]="true"
            [ariaLabel]="'components.imageSelector.clear' | translate"
            [pTooltip]="'components.imageSelector.clear' | translate"
            (onClick)="clearImage()" />
    }
</div>
